/**
 * HooksRegistryService 实现
 *
 * Hooks 注册服务的核心实现，负责 Hook 的注册、存储、查找和卸载。
 *
 * 注意：存储的是 Hook 函数的引用，消费方需在组件内调用。
 */
/**
 * Hooks 注册服务
 *
 * ui-registry-mod 的核心服务之一，业务 Mod 通过此服务注册可跨模块共享的 hooks。
 */
export class HooksRegistryService {
    constructor(deps) {
        this.hooks = {};
        this.modRegistry = new Map();
        this.eventBus = deps?.eventBusService;
    }
    registerHooks(modName, hooks) {
        // 校验 Hook 名冲突
        for (const key of Object.keys(hooks)) {
            if (this.hooks[key]) {
                throw new Error(`Hook conflict: ${key} already registered`);
            }
        }
        // 批量注册
        Object.assign(this.hooks, hooks);
        // 记录模块注册的 Hook 名
        if (!this.modRegistry.has(modName)) {
            this.modRegistry.set(modName, new Set());
        }
        for (const key of Object.keys(hooks)) {
            this.modRegistry.get(modName).add(key);
        }
        if (this.eventBus) {
            this.eventBus.emit('hook:registered', {
                modName,
                keys: Object.keys(hooks),
            });
        }
    }
    registerHook(modName, name, hook) {
        if (this.hooks[name]) {
            throw new Error(`Hook conflict: ${name} already registered`);
        }
        this.hooks[name] = hook;
        if (!this.modRegistry.has(modName)) {
            this.modRegistry.set(modName, new Set());
        }
        this.modRegistry.get(modName).add(name);
        if (this.eventBus) {
            this.eventBus.emit('hook:registered', {
                modName,
                keys: [name],
            });
        }
    }
    unregisterModHooks(modName) {
        const keys = this.modRegistry.get(modName);
        if (keys) {
            for (const key of keys) {
                delete this.hooks[key];
            }
            this.modRegistry.delete(modName);
        }
        if (this.eventBus) {
            this.eventBus.emit('hook:unregistered', { modName });
        }
    }
    getHooks() {
        return { ...this.hooks };
    }
    getHooksByMod(modName) {
        const keys = this.modRegistry.get(modName);
        if (!keys)
            return {};
        const result = {};
        for (const key of keys) {
            if (this.hooks[key]) {
                result[key] = this.hooks[key];
            }
        }
        return result;
    }
}
//# sourceMappingURL=hooks-registry.js.map